<template>
  <div
    v-if="loading"
    class="text-center"
  >
    <v-progress-circular
      color="primary"
      indeterminate
    />
  </div>
  <div
    v-else
  >
    <div
      v-if="!orderRecords.length"
      class="pt-3 pl-3"
    >
      No orders to list.
    </div>
    <order-card
      class="mb-6"
      v-for="record in orderRecordsSorted"
      :key="record.orderid"
      :value="record"
    />

    <div
      v-if="lastPage && lastPage > 1"
      class="text-center"
    >
      <v-pagination
        :value="page"
        :length="lastPage"
        :total-visible="$vuetify.breakpoint.mdAndUp ? 15 : 7"
        @input="changePage"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import PaginatedOrdersMixin from './PaginatedOrdersMixin'

export default {
  mixins: [
    PaginatedOrdersMixin
  ],
  data () {
    return {
      type: 'OPEN'
    }
  }
}
</script>
